
<template>
    <div class="toggleWrapper" @click="toggle">
        <div class="label">{{title}}</div>
        <div class="toggleBg" :class="toggleState"><div class="dot"></div></div>
    </div>
</template>

<script>
export default {
    name: 'toggle',
    props: ['title', 'storeRef'],
    default () {
        return {
        };
    },
    methods: {
        toggle () {
            this.$store.commit(`update${this.storeRef}`, !this.$store.state.ui[this.storeRef]);
        },
    },
    computed: {
        toggleState () {
            return this.$store.state.ui[this.storeRef] ? 'active' : 'inactive';
        },
    },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
@import 'src/assets/scss/all.scss';
.toggleWrapper {
    width: 130px;
    display: inline-block;
    vertical-align: middle;
    margin: 0 10px;
    .label {
        font-size: 12px;
        text-align: center;
        color: $darkGrey;
        font-weight: 400;
    }
    .toggleBg {
        height: 10px;
        width: 40px;
        margin: 0 auto;
        border-radius: 10px;
        position: relative;
        cursor: pointer;
        margin-top: 8px;
        margin-bottom: 10px;
        margin-left: auto;
        margin-right: auto;
        display: block;
        .dot {
            height: 20px;
            width: 20px;
            border-radius: 10px;
            position: absolute;
            top: -5px;
            cursor: pointer;
            -webkit-transition:all 0.5s ease-in-out;
            -moz-transition:all 0.5s ease-in-out;
            -o-transition:all 0.5s ease-in-out;
            transition:all 0.5s ease-in-out;
        }
        &.active {
            background: $lightBlue; /* Old browsers */
            background: -moz-linear-gradient(left, $lightBlue 0%, $darkBlue 100%); /* FF3.6-15 */
            background: -webkit-linear-gradient(left, $lightBlue 0%,$darkBlue 100%); /* Chrome10-25,Safari5.1-6 */
            background: linear-gradient(to right, $lightBlue 0%,$darkBlue 100%); /* W3C, IE10+, FF16+, Chrome26+, Opera12+, Safari7+ */
            filter: progid:DXImageTransform.Microsoft.gradient( startColorstr='$lightBlue', endColorstr='$darkBlue',GradientType=1 ); /* IE6-9 */
            .dot {
                left: 20px;
                background: $darkBlue;
            }
        }
        &.inactive {
            background: $grey; /* Old browsers */
            background: -moz-linear-gradient(left, $grey 0%, $midGrey 100%); /* FF3.6-15 */
            background: -webkit-linear-gradient(left, $grey 0%,$midGrey 100%); /* Chrome10-25,Safari5.1-6 */
            background: linear-gradient(to right, $grey 0%,$midGrey 100%); /* W3C, IE10+, FF16+, Chrome26+, Opera12+, Safari7+ */
            filter: progid:DXImageTransform.Microsoft.gradient( startColorstr='$grey', endColorstr='$midGrey',GradientType=1 ); /* IE6-9 */
            .dot {
                left: 0;
                background: $grey;
            }
        }
    }
}
</style>
